import { ACTION_EVENT, Snackbar, CLOSED_EVENT, SNACKBAR_TIMEOUT } from '../Snackbar/Snackbar';
export default {
    // tslint:disable-next-line:variable-name no-shadowed-variable
    install(Vue) {
        let uniqueCounter = 0;
        let currentSnackbarContextId = 0;
        // Queue for consecutive snackbar's options
        let queue = new Array();
        // Hold the snackbar reference
        // Create instance of snackbar only once
        const snackbar = new Snackbar({});
        snackbar.$mount();
        snackbar.$on(CLOSED_EVENT, () => {
            // All event subscriptions cleanup
            queue.shift();
            showNext();
        });
        snackbar.$on(ACTION_EVENT, () => {
            const currentSnackbar = queue[0];
            // Safety check to prevent undefined behavior
            if (!currentSnackbar) {
                return;
            }
            currentSnackbar.events
                .filter((x) => x.name === ACTION_EVENT)
                .forEach((x) => {
                x.handler();
            });
        });
        function makeSnackbarRepresentation(snackbar, context) {
            return {
                // If snackbar is opened and it is pointing to snackbar on which it is called
                // Then destroy this snackbar
                dismiss() {
                    if (snackbar.isOpened() && context.contextId === currentSnackbarContextId) {
                        snackbar.dismiss();
                    }
                },
                $on(eventName, handler) {
                    context.events.push({ name: eventName, handler });
                }
            };
        }
        function showNext() {
            // May have next pending snackbar to show
            const nextItem = queue[0];
            if (nextItem) {
                snackbar.timeout = nextItem.data.timeout || SNACKBAR_TIMEOUT;
                snackbar.message = nextItem.data.message;
                snackbar.action = nextItem.data.action;
                snackbar.type = nextItem.type;
                snackbar.open();
                currentSnackbarContextId = nextItem.contextId;
            }
        }
        function open(data, type) {
            // Step 1: Make context for snackbar
            // It will hold events
            const context = {
                contextId: uniqueCounter++,
                type,
                data,
                events: []
            };
            // Step 2: Add the snackbar to queue.
            queue.push(context);
            // Step 3: Create a representation of snackbar to allow user to interact
            // with a snackbar in a limited way.
            const representation = makeSnackbarRepresentation(snackbar, context);
            // Step 4: Adjust queue. Check that there is not pending snackbar.
            // If there is only one item to show, show it now.
            if (queue.length === 1) {
                showNext();
            }
            return representation;
        }
        function success(data) {
            return open(data, 'success');
        }
        function error(data) {
            return open(data, 'error');
        }
        function info(data) {
            return open(data, 'info');
        }
        function warn(data) {
            return open(data, 'warn');
        }
        // Once this gets called snackbar queue becomes empty and active snackbar gets dismiss
        function dismiss() {
            queue = [];
            if (snackbar.isOpened()) {
                snackbar.dismiss();
            }
        }
        Vue.prototype.$snackbar = {
            // Core methods
            open, dismiss,
            // Helper wrapper methods
            success, error, info, warn
        };
    }
};
//# sourceMappingURL=SnackbarPlugin.js.map